var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_562_1959",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_562_1959",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEIElEQVR4nO2aSWyNURTHXyklKqgqMYRamQmJsCeGpCgrylJY6cDGBrFCWNVQIRZWYmmoYUElYiaIGKpEzCkikRha2p8cPS+5efne9917362W9J80fXn3DN//nXvPPffcL5XqwX8KYDCwBNgFnAQeAR+A7/onnx8CJ1SmDBiU6g4ACoAK4CzwC3eIzhlgldhKdQGBfkAN8MZ4qB9AA7AVKAcmA0NVtp9+ngIsV5lLQIuh/xqoEtm/RWIR0GQ8wG1gHTDEw9YQ1b1j2HsKLOjsKOw3HIrzhYFs5+kPdNewXxt8ugHDgVvq4BtQCfQO6qTDTz5QrclBcAMoCWV8nIZb8BiYmiA/EdgMXASeKfGvwHPgKDDXwud0oFF9yv9xISKRJnFNFmyMbDFwBGhLyFTtwHaRT/BdDFw3yJTksibS0+kqUBgjWwI8wA0/gYPAgBi7hQaZG15rBjhgTKe4SPQCLuMP0e2bEJlGld3rSmKxKn6zWBMryB2bEnzMMBKAXWoG+usiFWywkJdyJFe8sPBTrbKNVlMM2GjsE70t8v8XwmC8RWq+p7KVNgv8jW0IgWGEwzyHKf86NirAahW8lWRU5UcEJLLMwl+eUc6sjBM8r0JrLYlI2g0Fq0UMrFf5+rgC7pdWsYMtjQ7UDS4EJlj6LNKq+WfkeUZCqwYv2Bg09F4GINHmUr7TcQQQlEUN7tbBLY5E6gMQue/oc5vq7YoaPKWDSx2N7gtA5Iijz3LVOxE1mC4DJjoYlPLkXQAib8VWyt6vnD4Fj6MGP+lgkYNBWXih4OI3vX81Rw2mz89ZC7gInT5aj+WKHy6VLR1Njz96QYionnRQcsUZR58FqtcSZGqp3iw9AfpCdGc6+ixW3Y9xi91qY8qSRXxQ7uFvUtxir/dJv0aomz1IvHedyhmb96lUJoA9Phuiob/Jg0iNp6+tcRuiV4mSkcFuOpCQM3i+p6+GuBJlqBZi1kVjhI3RDkRGefoo0gzbmvU5gXMuZXyWqNjCNxrrVP90nNAaFbrj6UTaN7Yo9LCfZxysKpKyT/qo69zXBUodiJR62F+suq8Ss52Rfe66hF9bq9KNtIU0/cY62M+Xcl91q2wUCox2UKICMBs45Lm7i85hYI6FnxrVabTeezSE7doUm5alRNiQcQ2QK+TXro7q8RoNunbnKW+0TJ+kG87aJT+WcdMUGq3AcXl4o2RPN9JrnUgYHcfrxnzeZ9FpD4k2oM5Yd1e8r+W0byX3Gl2NZ3LF4UXCIDPGCG1X4LlPqs5GZqRjag2FKzIrgpDI6AvXBWzIxaFd12Tn3b1L+uvkddMEzO80AhGbZrW2cUJBSqNKn4NWCEJ99fWLs5r/XdGir3CslMo51R2gTXA5nO3UY7O8QPPZeOjP+p2M7ZAjtc/bEj1I/SP4DZI1epJ9LEGlAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/male.fd3568912eb7c5a4fccbdf3e3daec4c5.svg";
export { ForwardRef as ReactComponent };